const transRarity = {
  0: 'normal',
  1: 'rare',
  2: 'superRare',
  3: 'ultraRare',
};

const deliveryStatus = {
  0: '対象外',
  1: '未発送',
  2: '発送済み',
};

const shopLink = {
  '(minny通販店で)': 'https://www.iranoan.com/blank-3/%E3%83%A6%E3%82%A6%E3%83%AA%E3%83%BC-%E3%81%A7%E4%BD%BF%E3%81%88%E3%82%8B%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88',
};

const ExchangeSearch = {
  0: '値段の高い順',
  1: '値段の低い順',
  2: '在庫の多い順',
  3: '在庫の少ない順',
};

export {
  transRarity,
  deliveryStatus,
  shopLink,
  ExchangeSearch,
};
